(function(){
    document.addEventListener('DOMContentLoaded', function() {
     let active = false;
      console.log('bef0re');
      function scrollIt( x, element ) {
          let transform = Math.max(0, (Math.min(x, element.offsetWidth)));
          let fullWidth = element.offsetWidth;
          let curElem = element.querySelector('.after');
          curElem.style.width = (fullWidth - transform) + "px";
          element.querySelector('.scroller').style.left = transform - 25 + "px";
      }
      
      document.querySelectorAll('.scroller').forEach( elem => {
        elem.addEventListener('mousedown', function() {
          active = true;
          elem.classList.add('scrolling');
        });
        

        elem.addEventListener('touchstart', function() {
          active = true;
          elem.classList.add('scrolling');
        });
      });

      function wrapperActions() {
        let itemsBeforeAfter = document.querySelectorAll('.before_after .iman .wrapper');
        itemsBeforeAfter.forEach( elem => {
          elem.addEventListener('mouseup', function() {
            active = false;
            elem.querySelector('.scroller').classList.remove('scrolling');
          });
          elem.addEventListener('mouseleave', function() {
              active = false;
              elem.querySelector('.scroller').classList.remove('scrolling');
          });
          
          elem.addEventListener('mousemove', function(e) {
              if (!active) return;
              let x = e.pageX;
              x -= elem.getBoundingClientRect().left;
              scrollIt( x, elem );
          });
  
          elem.addEventListener('touchend', function() {
            active = false;
            elem.querySelector('.scroller').classList.remove('scrolling');
          });
          elem.addEventListener('touchcancel', function() {
              active = false;
              elem.querySelector('.scroller').classList.remove('scrolling');
          });
          elem.addEventListener('touchmove', function(e) {
              if (!active) return;
              let x = e.pageX;
              if (window.innerWidth < 1024) {
                  var touch = e.touches[0];
                  x = touch.pageX;
              }
          
              x = e.pageX || e.touches[0].pageX;
          
              x -= elem.getBoundingClientRect().left;
              console.log(document.querySelector('.wrapper').getBoundingClientRect().left);
              scrollIt(x, elem);
          });
          let widthElems = elem.offsetWidth / 2;
          scrollIt(widthElems, elem);
        });
      }
      wrapperActions();
      
      
      function resizeImageBeforeAfter() {
          const contentImages = document.querySelectorAll('.before_after .content-image');
          const wrapperWidth = document.querySelector('.before_after .wrapper').offsetWidth;
      
          contentImages.forEach(function(image) {
              image.style.width = wrapperWidth + 'px';
              const imanElement = image.closest('.slide_content');
              if (imanElement) {
                imanElement.style.height = wrapperWidth * 0.588 + 'px';
              }
          });
      }
      
      resizeImageBeforeAfter();
      
      window.addEventListener('resize', function() {
          resizeImageBeforeAfter();
      });

      if ( window.innerWidth > 749 &&  document.querySelectorAll('.before_after') ) { //init swiper for section
        let sliderThumbnail = new Swiper('.before_after', {
          spaceBetween: 20,
          autoHeight: true,
          slidesPerView: 3,
          grabCursor: false,
          noSwiping: true,
          allowTouchMove: false,
          on: {
            init: function () {
              resizeImageBeforeAfter();
              wrapperActions();
            }
          },
          navigation: {
            nextEl: '.swiper-button-next.before_after_arr',
            prevEl: '.swiper-button-prev.before_after_arr',
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            500: {
              slidesPerView: 2,
            },
            640: {
              slidesPerView: 3,
            }
          }
        });
      } else {
        let swiperElement = document.querySelector('.before_after');
        
        swiperElement?.querySelectorAll('.swiper-wrapper').forEach(elem => {
          elem.classList.remove('swiper-wrapper');
        });
        swiperElement?.querySelectorAll('.swiper-slide').forEach(elem => {
          elem.classList.remove('swiper-slide');
        });
        document.querySelectorAll('.before_after_arr').forEach(elem => {
          elem.remove();
        });
        swiperElement?.classList.remove('swiper');
      }
      
  }, false);
})();